export const MOBILE_VIEW = 'mobile'
export const DESKTOP_VIEW = 'desktop'

export type View = typeof MOBILE_VIEW | typeof DESKTOP_VIEW

export function isMobile(view: string): boolean {
  return view === MOBILE_VIEW
}
